/**
 * Zod schema for the `sessionInternals` collection.
 *
 * Operational logistics for a session — readable only by
 * internal/organizer/admin members of the event. Document ID matches the
 * session ID (1:1 relationship).
 */

import { z } from 'zod';

export const sessionInternalDocumentSchema = z.object({
  sessionId: z.string(),
  eventId: z.string(),
  /** Operational logistics. */
  notes: z.string().nullable(),
  /** F&B details. */
  menuDetails: z.string().nullable(),
  /** Staff assignments, setup instructions. */
  staffNotes: z.string().nullable(),
});
